import SourcesImg from 'images/console-menu/sources.svg';
import ChannelsImg from 'images/console-menu/channels.svg';
import UsersImg from 'images/console-menu/users.svg';
import WarehousesImg from 'images/console-menu/warehouses.svg';

import { isConsoleItemHidden } from 'config/helpers';

import Channels from 'components/IterioApp/Channels/Channels';
import Sources from 'components/IterioApp/Sources/Sources';
import { Warehouses } from 'components/IterioApp/Warehouses/Warehouses';
import Users from 'components/IterioApp/Users/Users';

const routes = [
  {
    exact: true,
    path: '/channels',
    component: Channels,
    title: 'Channels',
    showTitle: true,
    icon: ChannelsImg,
    transition: false,
  },
  {
    exact: true,
    path: '/sources',
    component: Sources,
    title: 'Sources',
    showTitle: true,
    icon: SourcesImg,
    transition: false,
  },
  {
    exact: false,
    path: '/users/:user_id?/:view_name?',
    pathBase: '/users',
    component: Users,
    title: 'Users',
    showTitle: false,
    icon: UsersImg,
    transition: false,
  },
  {
    exact: true,
    path: '/warehouses',
    component: Warehouses,
    title: 'Warehouses',
    showTitle: true,
    icon: WarehousesImg,
    transition: false,
  },
];

export default routes.filter(isConsoleItemHidden);



// WEBPACK FOOTER //
// ./src/components/IterioApp/routes.js